import {UIGameCityImprovementProgressTrackerController} from '../../../../shared/scripts/ui_game/ui_game_cities_and_knights/UIGameCityImprovementProgressTrackerController'
import {UIGamePlayerInformationCityImprovementProgressTrackerView} from '../../../../shared/scripts/ui_game/ui_game_cities_and_knights/UIGamePlayerInformationCityImprovementProgressTrackerView'
import {UIGamePlayerInformationView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationView'

export class UIWGameCityImprovementProgressTrackerController extends UIGameCityImprovementProgressTrackerController {
    protected getMyCityImprovementProgressTrackerSectionView(playerInformation: UIGamePlayerInformationView): UIGamePlayerInformationCityImprovementProgressTrackerView {
        const playerInformationW = playerInformation.width
        const playerInformationH = playerInformation.height

        const progressTrackerSectionX = playerInformationW * 0.6463
        const progressTrackerSectionY = playerInformationH * 0.34
        const progressTrackerSectionW = playerInformationW * 0.105
        const progressTrackerSectionH = playerInformationH * 0.5556

        return new UIGamePlayerInformationCityImprovementProgressTrackerView(this.uiGameManager, this.cityImprovementsState, playerInformation.playerState.color, progressTrackerSectionX, progressTrackerSectionY, progressTrackerSectionW, progressTrackerSectionH, playerInformation)
    }

    protected getOpponentCityImprovementProgressTrackerSectionView(playerInformation: UIGamePlayerInformationView): UIGamePlayerInformationCityImprovementProgressTrackerView {
        const playerInformationW = playerInformation.width
        const playerInformationH = playerInformation.height

        const progressTrackerSectionX = playerInformationW * 0.6463
        const progressTrackerSectionY = 0
        const progressTrackerSectionW = playerInformationW * 0.105
        const progressTrackerSectionH = playerInformationH * 0.9655

        return new UIGamePlayerInformationCityImprovementProgressTrackerView(this.uiGameManager, this.cityImprovementsState, playerInformation.playerState.color, progressTrackerSectionX, progressTrackerSectionY, progressTrackerSectionW, progressTrackerSectionH, playerInformation)
    }
}
